import { useState, useEffect } from 'react';
import api from '../api/client';

// In-memory cache across component renders
const cache = {};

/**
 * Returns array of { value, label } from master_data for a given type.
 * Cached after first fetch so repeated calls don't hit the API.
 */
export function useMasterValues(type) {
  const [values, setValues] = useState(cache[type] || []);
  useEffect(() => {
    if (cache[type]) { setValues(cache[type]); return; }
    api.get(`/master-files/values/${type}`)
      .then(r => { cache[type] = r.data || []; setValues(cache[type]); })
      .catch(() => {});
  }, [type]);
  return values; // [{value, label, parent}]
}

/** Invalidate a type so it re-fetches next time (call after adding to master files) */
export function invalidateMaster(type) {
  delete cache[type];
}

// Note: useMasterValues must be called at the top level of a component,
// never in loops. Call it separately for each type needed.
